import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import { documentDownloadUrl } from './documentUrl';

function isPdf(filename) {
  return /\.pdf$/i.test(filename || '');
}

export function useDocumentPreview() {
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState(null);
  const [title, setTitle] = useState('Documento');

  function close() {
    setVisible(false);
    if (url) {
      URL.revokeObjectURL(url);
    }
    setUrl(null);
  }

  async function open(filename, docTitle) {
    if (!filename) {
      message.error('Arquivo não encontrado.');
      return;
    }

    if (!isPdf(filename)) {
      window.location.href = documentDownloadUrl(filename, { download: true });
      message.info('Este arquivo não é PDF. Ele será baixado para abrir no Word.');
      return;
    }

    const fileUrl = documentDownloadUrl(filename);
    try {
      const response = await fetch(fileUrl);
      const contentType = (response.headers.get('content-type') || '').toLowerCase();
      if (!response.ok || !contentType.includes('pdf')) {
        message.error('Não foi possível abrir o PDF.');
        return;
      }
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      setTitle(docTitle || 'Documento');
      setUrl(objectUrl);
      setVisible(true);
    } catch (error) {
      message.error('Não foi possível abrir o PDF.');
    }
  }

  const modal = (
    <Modal
      visible={visible}
      title={title}
      onCancel={close}
      width="90%"
      destroyOnClose
      footer={[
        <Button key="close" onClick={close}>Fechar</Button>,
      ]}
    >
      {url && (
        <iframe
          title={title}
          src={url}
          style={{ width: '100%', height: '75vh', border: 'none' }}
        />
      )}
    </Modal>
  );

  return { open, modal };
}
